import { TenantInfoTheme } from '../../interface/tenant';
import breakpoints from './breakpoints';
import colors from './colors';
import fontSize from './fontSize';

const defaultTheme = {
  breakpoints,
  colors,
  fontSize,
  logo: {
    dashboard: '/images/YEM-Orange-Gradient.svg',
    login: '/images/YEM-Orange-Gradient.svg',
  },
};

export const overrideTheme = (customTheme: TenantInfoTheme) => ({
  ...defaultTheme,
  logo: {
    dashboard: customTheme.dashboardLogo,
    login: customTheme.loginLogo,
  },
  colors: {
    ...defaultTheme.colors,
    ...customTheme,
  },
});

export default defaultTheme;
